import { __ } from '../symbols';
/**
 * Return true when the input value is a Placeholder,otherwise false
 * @param a
 */
const isPlaceholder = (a:String):boolean=>a === __;

export default isPlaceholder;



// WEBPACK FOOTER //
// ./src/internal/isPlaceholder.ts